exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tags[data-v-f1104828] {\n  margin-bottom: 0;\n}\n.tags > label[data-v-f1104828] {\n  font-weight: bold;\n  font-size: 16px;\n  line-height: 1;\n  margin-bottom: 11px;\n  padding-left: 5px;\n}\n.tags > label > a[data-v-f1104828] {\n  position: relative;\n  top: 2px;\n  left: 2px;\n  font-size: 20px;\n  cursor: pointer;\n}\n", ""]);

// exports
